 <div class="other-version-modal">
    <div class="other-version-item-container" *ngFor = "let file of otherVersions" [ngClass]="{'active': file.isActive===true}">
      <div class="pdf-list">
<!--        <div class="blue-dot-sm">&nbsp;</div>-->
        <i class="fa fa-folder-open"></i>
        <a (click) ="showPdf(file)">
          <span *ngIf = "file.title">{{file.title}}</span>
          <span *ngIf = "file.language"> - {{file.language}}</span>
          <span *ngIf = "file.format"> - {{file.format}}</span>
        </a>
      </div>
    </div>
 </div>
